import { e as __rest, c as __assign } from '../../../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var BannersSectionItemComponent = function (_a) {
    var children = _a.children, isActive = _a.isActive, isPrev = _a.isPrev, withTransition = _a.withTransition;
    return (React__default.createElement("div", { className: "lobby-top-slide ".concat(isActive ? 'active' : '', " ").concat(isPrev ? 'prev' : ''), style: withTransition ? {} : { transition: '0s' } }, children));
};
var Video = function (_a) {
    var src = _a.src, autoPlay = _a.autoPlay, muted = _a.muted, loop = _a.loop, rest = __rest(_a, ["src", "autoPlay", "muted", "loop"]);
    return (React__default.createElement("video", __assign({ src: src, autoPlay: autoPlay, muted: muted, loop: loop }, rest)));
};
var Img = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b, rest = __rest(_a, ["src", "alt"]);
    return React__default.createElement("img", __assign({ src: src, alt: alt }, rest));
};
var BannersSectionItem = Object.assign(BannersSectionItemComponent, {
    Video: Video,
    Img: Img,
});

export { BannersSectionItem };
